import {
    Component, ContentChild, Input, TemplateRef
} from "@angular/core";

@Component({
    selector: 'app-wizard-dialog-step',
    template: '',
    standalone: false
})
export class WizardDialogStepComponent {
    @ContentChild('template') template: TemplateRef<any>;
    @Input() stepId: string;
    @Input() title: string;
    @Input() isVisible = true;
    @Input() isValid = true;
    @Input() status = "upcoming";
    @Input() headerGlyph = "accept";
}
